/**
 * @param  {Object} state
 * @return {Object}
 */
export const talent = state => {
  return state.data
}



// WEBPACK FOOTER //
// ./src/store/modules/talent/getters.js